import { createSelector } from 'reselect';

import { IApplicationState } from '../../types/redux';
import { selectIsResultsLoading } from '../results';

const selectNonGeoParameters = (state: IApplicationState) => {
  const { nonGeoOffersCount, hasNoneGeoParametersBeenSet } = state.nonGeoParameters;

  const hasNonGeoOffersCount = nonGeoOffersCount !== null && (nonGeoOffersCount || 0) > 0;

  return { hasNonGeoOffersCount, hasNoneGeoParametersBeenSet };
};

export const selectShouldShowSearchInThisArea = createSelector(
  selectIsResultsLoading,
  selectNonGeoParameters,
  (isLoading, { hasNonGeoOffersCount, hasNoneGeoParametersBeenSet }) => {
    if (isLoading || hasNoneGeoParametersBeenSet) {
      return false;
    }

    return hasNonGeoOffersCount;
  },
);
